export const getHistoryTotal = state => state.reports.history && state.reports.history.total ?
    state.reports.history.total : 0;
export const getHistoryData = state => state.reports.history && state.reports.history.data ?
    state.reports.history.data : null;
export const getHistoryPage = state => state.reports.historyPage;
export const getIsHistoryLoading = state => state.reports.historyFetchStatus.loading;
export const getHasHistoryFetchFailed = state => state.reports.historyFetchStatus.error;
export const getHistoryFetchRetriesCount = state => state.reports.historyFetchStatus.retryCount;
export const getHistoryFilters = state => state.reports.reportsListFilters;

export const getHistoryManageModeIsOn = state => state.reports.historyManageMode.isOn;
export const getHistoryManageModeSelectedEntries = state => state.reports.historyManageMode.selectedEntries;



// WEBPACK FOOTER //
// ./app/web/src/selectors/reportsHistorySelectors.js